import PageHero from "@/components/feature/PageHero";
import CtaSection from "@/components/feature/CtaSection";
import Reveal from "@/components/base/Reveal";
import { howItWorksSteps } from "@/mocks/public";

export default function HowItWorksPage() {
  return (
    <div className="flex flex-col">
      <PageHero
        eyebrow="Comment ça marche"
        current="Comment ça marche"
        title="Le parcours complet, de l'inscription au suivi des loyers"
        description="Suivez ces onze étapes pour structurer votre gestion immobilière et ne plus rien laisser au hasard."
      />

      <section className="py-14 md:py-20 bg-background-50">
        <div className="container-page">
          <ol className="relative flex flex-col gap-4">
            {howItWorksSteps.map((step, index) => (
              <Reveal as="li" key={step.step} delay={Math.min(index, 6) * 60}>
                <div className="card-lift flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 md:flex-row md:items-center md:gap-6">
                  <div className="flex items-center gap-4 md:w-64 md:shrink-0">
                    <span className="font-heading text-3xl font-semibold text-primary-500">{step.step}</span>
                    <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-secondary-50 text-secondary-600">
                      <i className={`${step.icon} text-xl`} aria-hidden="true" />
                    </span>
                  </div>
                  <div>
                    <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-950">{step.title}</h2>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.description}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <CtaSection
        title="Commencez par la première étape dès maintenant."
        description="L'inscription prend quelques minutes et la formule gratuite ne nécessite aucune carte bancaire."
      />
    </div>
  );
}